import { smbMachine } from '~/machines/smb-funnel';
import { getInitialState } from '~/utils/funnels';
import { config } from './config';

export const funnelMachine = () =>
  smbMachine({
    id: config.id,
    initialState: getInitialState(config.id, smbMachine),
    user: {
      context: { requirePhone: true },
    },
  });
